import { RootState } from "../../redux";

import { AppDispatch } from "../../redux";

import { useDispatch, useSelector } from "react-redux";

import { createIntegration, Integration } from "../../redux/integration/integrationSlice";

const useCreateIntegration = () => {    
    const dispatch = useDispatch<AppDispatch>();
    const integrationState = useSelector((state: RootState) => state.integration);
    const integration = integrationState?.integration || null;
    const loading = integrationState?.isLoading || false;
    const error = integrationState?.error || null;

    const createIntegrationAction = async (integration: Integration) => {
        // unwrap() rethrows on rejection so callers can react to real API failures
        return await dispatch(createIntegration(integration)).unwrap();
    }
    
    return {
        integration,
        loading,
        error,
        createIntegrationAction
    }
}

export default useCreateIntegration;